import styled from "@mui/material/styles/styled";
import { PickersDay } from "@mui/x-date-pickers";
import { Stack } from "../../../..";
import { dayjs } from "../../../../../shared/libs";
const DatePickerHeader = styled(Stack)`
  padding: 0 8px;
  justify-content: center;
`;
const StackHeaderStyled = styled(Stack)`
  width:100%;
  flex-direction:row;
  align-items:center ; 
  justify-content: space-between;
  padding: 0 8px;
`;
const PickersDayWeekTypeStyled = styled(PickersDay)(({ $viewType, $selectedDay, theme, isSelected, isHovered, day }) => {
  const endOfMonth = dayjs($selectedDay).endOf("month");
  const startOfMonth = dayjs($selectedDay).startOf("month");
  return {
    padding: "0!important",
    position: "relative",
    zIndex: "1",
    "&:hover, &:focus": {
      background: "none!important",
      outline: "none!important"
    },
    ...isSelected && {
      color: "var(--mui-palette-elevation1-contrast)!important",
      "&::before": {
        content: '""',
        zIndex: -2,
        backgroundColor: "var(--mui-palette-elevation3-main)",
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        borderRadius: "8px"
      },
      ...$viewType === "month-date" && (day.isSame(startOfMonth, "day") || day.isSame(endOfMonth, "day")) && {
        "&::after": {
          content: '""',
          zIndex: -1,
          backgroundColor: "var(--mui-palette-brand-main)",
          position: "absolute",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          borderRadius: "8px"
        }
      },
      ...$viewType === "week-date" && (day.day() === 0 || day.day() === 1) && {
        "&::after": {
          content: '""',
          zIndex: -1,
          backgroundColor: "var(--mui-palette-brand-main)",
          position: "absolute",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          borderRadius: "8px"
        }
      }
    },
    ...isHovered && {
      "&::before": {
        content: '""',
        backgroundColor: "var(--mui-palette-elevation3-main)",
        position: "absolute",
        zIndex: -2,
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        borderRadius: "8px"
      }
      // ...((day.day() === 0 || day.day() === 1) && {
      //   '&::after': {
      //     content: '""',
      //     zIndex: -1,
      //     backgroundColor: 'var(--mui-palette-brand-main)',
      //     position: 'absolute',
      //     top: '0',
      //     left: '0',
      //     right: '0',
      //     bottom: '0',
      //     borderRadius: '8px',
      //   },
      // }),
    }
  };
});
export {
  DatePickerHeader,
  PickersDayWeekTypeStyled,
  StackHeaderStyled
};
